import { States } from 'safe'
import {
  RatesTypes,
  SET_RATES,
} from '../actions/actionTypes'

const initialState: States.Rates = {
  rates: [],
}

const ratesReducer = (state = initialState, action: RatesTypes): States.Rates => {
  switch (action.type) {
    case SET_RATES:
      return { ...state, rates: action.payload }
    default:
      return state
  }
}

export default ratesReducer